module.exports = __webpack_public_path__ + "static/media/BR.8909bc2f.svg";